<template>
    <v-col cols="12" class="mt-4">
      <!-- Cuadro de dialogo de advertencia al momento de eliminar un registro -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="eliminar" persistent max-width="550px" :key="eliminar">
          <v-card>
            <v-card-title class="headline" style="word-break: break-word;">¿Está seguro que desea eliminar este registro?</v-card-title>
            <v-card-text>Esta acción no se puede revertir y será permanente.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="eliminar = false; delItem = '';">Cancelar</v-btn>
              <v-btn color="red darken-1" text @click="eliminar = false; deleteItemDB()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
      <!-- Se declara la tabla y sus componentes  -->
      <v-data-table
      :headers="headers"
      :items="filasOrdenadas"
      :loading="loading"
      loading-text="Cargando... Espere, Por Favor."
    >
    <template v-slot:top>
          <v-toolbar flat color="white">
            <v-dialog v-model="dialog" persistent max-width="500px" :key="dialog">
              <!-- Boton para crear un nuevo registro -->
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on" >Asignar persona</v-btn><!-- v-if="permisoVista('parotipos','c')" -->
              </template>
              <!-- Formulario de edicion o de creacion -->
              <v-card>
                <!-- Titulo del formulario, cambiara con forme lo que dicte la funcion formTitle -->
                <!-- Si se abrio desde el boton de un nuevo registro mandara un formurario vacio -->
                  <!-- Si se abre desde el boton de edicion mandara el formulario con los datos del registro a editar -->
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <!-- Cuerpo del formulario -->
                <v-card-text>
                  <v-container>
                    <v-row>
                      <!-- Formulario de edidion o creación -->
                      <!-- En el caso de que se este creando un nuevo registro se mostrara un formulario vacio -->
                      <!-- En el caso de que se este editando un registro se mostrara el formulario con los datos del registro a editar, los cuales sacara de la variable editItem -->
                      <v-col justify="center" cols="12" sm="12" md="12">
                        <!-- combobox de los usuarios, traera una lista de usuarios disponibles para el registro a su dispocision -->
                        <v-combobox
                          v-model="editedItem.usuario"
                          :items="usuarios"
                          item-text="nombre"
                          item-value="idUsuario"
                          label="Usuario"
                          return-object                         
                        ></v-combobox>
                      </v-col>
                      <v-col justify="center" cols="12" sm="12" md="12" >
                        <!-- combobox de las secciones, traera una lista de secciones disponibles para el registro a su dispocision -->
                        <!-- Se le agrego instrucciones al momento de que el valor dentro del recuadro cambie -->
                        <v-combobox
                          v-model="editedItem.seccion"
                          :items="seccionNotificaciones"
                          item-text="nombre"
                          item-value="idSeccionNotificacion"
                          label="Sección"
                          @change="getSubSecciones(); editedItem.subSeccion='';"
                        ></v-combobox>
                      </v-col>                    
                      <v-col justify="center" cols="12" sm="12" md="12" @click="validateList()">
                        <!-- combobox de las subsecciones, traera una lista de subsecciones disponibles para el registro a su dispocision  -->
                        <!--  -->
                        <v-combobox
                          v-model="editedItem.subSeccion"
                          :items="subSeccionesNotificaciones"
                          item-text="nombre"
                          item-value="idSubSeccion"
                          label="Subsecciones"                        
                        ></v-combobox>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="mt-0 pt-0">
                        <v-autocomplete
                          v-model="editedItem.causa"
                          :items="causas"
                          item-value="idParoTipo"
                          item-text="nombre"
                          label="Causa (opcional)"
                          hide-details
                          clearable
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="12" sm="12" class="mt-0 pt-0">
                        <v-autocomplete
                          v-model="editedItem.subcausa"
                          :items="subcausasFiltradas"
                          item-value="idSubParoTipo"
                          item-text="nombreSubParoTipo"
                          label="Subcausa (opcional)"
                          hide-details
                          clearable
                        ></v-autocomplete>
                      </v-col>  
                      <v-col justify="center" cols="12" sm="12" md="12">
                        <!-- combobox de los medios de envio, traera una lista de los medios de envio disponibles para el registro a su dispocision -->
                        <v-combobox
                          v-model="editedItem.medioEnvio"
                          :items="medios"
                          item-text="medioEnvio"
                          item-value="idMedioEnvio"
                          label="Medio"
                        ></v-combobox>
                      </v-col>
                      <!-- Checkbox para activar o desactivar el registro -->
                      <v-col cols="6" sm="6" md="6">
                        <p class="mb-0">
                          ¿Activo?
                        </p>
                        <div class="d-flex">
                          <v-btn-toggle
                            v-model="editedItem.activo"
                            class="my-3"
                          >
                          <!-- Se agregan 2 botones para configurar un valor booleano -->
                            <v-btn
                              depressed
                              small
                              class="ma-0"
                              :color="
                                editedItem.activo == 0
                                  ? 'success'
                                  : 'grey lighten-1'
                              "
                              >Si</v-btn
                            >
                            <v-btn
                              depressed
                              small
                              class="ma-0"
                              :color="
                                editedItem.activo == 1
                                  ? 'error'
                                  : 'grey lighten-1'
                              "
                              >No</v-btn
                            >
                          </v-btn-toggle>
                        </div>
                      </v-col>
                      <!-- CheckBox para activar o desactivar el llamado a mantenimiento del registro -->
                      <v-col cols="6" sm="6" md="6">
                        <p class="mb-0">
                          ¿Llamado a Mantenimiento?
                        </p>
                        <div class="d-flex">
                          <v-btn-toggle
                            v-model="editedItem.mantenimiento"
                            class="my-3"
                          >
                          <!-- Se agregan 2 botones para configurar un valor booleano -->
                          <v-btn
                              depressed
                              small
                              class="ma-0"
                              :color="
                                editedItem.mantenimiento == 0
                                  ? 'success'
                                  : 'grey lighten-1'
                              "
                              >Si</v-btn
                            >
                            <v-btn
                              depressed
                              small
                              class="ma-0"
                              :color="
                                editedItem.mantenimiento == 1
                                  ? 'error'
                                  : 'grey lighten-1'
                              "
                              >No</v-btn
                            >                          
                          </v-btn-toggle>
                        </div>
                      </v-col>
                      
                    </v-row>
                    <!-- <ul>
                      <li class="red--text" v-for="ex in errores" :key="ex">{{ ex }}</li>
                    </ul> -->
                  </v-container>
                </v-card-text>
                <!-- Configuracion de los botones que van incluidos en el formulario -->
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <!-- Boton para cancelar la accion y dejar todo como estaba -->
                  <v-btn color="blue darken-1" text :disabled="saving" @click="close(); dialog=false; errores=[]; subSeccionesNotificaciones= [];">Cancelar</v-btn>
                  <!-- Boton para guardar los cambios -->
                  <v-btn color="red darken-1" text @click="save()" :disabled="saving" :loading="saving">
                    Guardar
                    <template v-slot:loader>
                      <v-progress-circular
                        indeterminate
                        :width="2"
                        :size="24"
                        color="red"
                      ></v-progress-circular>
                    </template>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-spacer></v-spacer>          
          </v-toolbar>
    </template>

      <template v-slot:[`item.activo`]="{ item }">{{ item.activo ? 'SI' : 'NO' }}</template>
      <template v-slot:[`item.mantenimiento`]="{ item }">{{ item.mantenimiento ? 'SI' : 'NO' }}</template>

      <template v-slot:[`item.causaNombre`]="{ item }">
        {{ item.causaNombre || (nombreCausas[item.idParoTipo] || 'N/D') }}
      </template>
      <template v-slot:[`item.subcausaNombre`]="{ item }">
        {{ item.subcausaNombre || (nombreSubcausas[item.idSubParoTipo] || 'N/D') }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editar(item)">edit</v-icon>
        <v-icon small @click="deleteItem(item.idNotificacion)">delete</v-icon>
      </template>

      <!-- encabezado de grupo (opcional) -->
      <template v-slot:[`group.header`]="{ group, toggle, isOpen, headers, items }">
        <tr class="grey lighten-4">
          <td :colspan="headers.length">
            <v-btn icon x-small @click="toggle">
              <v-icon>{{ isOpen ? 'mdi-chevron-down' : 'mdi-chevron-right' }}</v-icon>
            </v-btn>
            <strong>{{ group.depth === 0 ? 'Sección' : 'Subsección' }}:</strong> {{ group.value }}
            <span class="ml-2 grey--text text--darken-1">({{ items.length }} registro{{ items.length!==1?'s':'' }})</span>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Refrescar</v-btn>
      </template>
    </v-data-table>

    <v-snackbar
      v-model="alerta"
      top
      color="error"
    >
      <!-- Un cuadro de advertencia que describe el error que se produjo -->
      <!-- Verifique la informacion ingresada en el registro -->
      {{ errores[errores.length-1] }}
      <v-btn
        text
        @click="alerta = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-col>
</template>

<script>
import axios from "axios";
export default {
    data: () => ({      
        //Se declaran los encabezados de cada columna de la tabla
        headers: [
        {
          text: 'Seccion',
          align: 'center',
          sortable: true,
          value: 'seccion',
        },
        {
          text: 'Subseccion',
          align: 'center',
          sortable: true,
          value: 'subseccion',
        },
        {
          text: 'Causa',
          align: 'center',
          sortable: true,
          value: 'causaNombre',
        },
        {
          text: 'Subcausa',
          align: 'center',
          sortable: true,
          value: 'subcausaNombre',
        },
        {
          text: 'Usuario',
          align: 'center',
          sortable: true,
          value: 'usuario',
        },
        {
          text: 'Medio',
          align: 'center',
          sortable: true,
          value: 'medio',
        },
        {
          text: 'Activo',
          align: 'center',
          sortable: true,
          value: 'activo',
        },
        {
          text: '¿Llamado a Mantenimiento?',
          align: 'center',
          sortable: true,
          value: 'mantenimiento',
        },
        { 
          text: 'Acciones', 
          value: 'actions', 
          sortable: false, 
          align:'center' },
      ],
      //Se declaran las variables que usaremos para el funcionamiento de las funciones de la tabla
      loading: false,
      dialog: false,
      alerta: false,
      delItem: -1,
      eliminar: false,
      saving: false,
      action: 0,
      errores: [],
      errorTiempo: null,
      editedIndex: -1,      //Una bandera que nos permitira saber si estamos editando o creando un nuevo registro      
      ups:0,
      seccionNotificaciones: [],//Listas de los registros disponibles para la tabla
      subSeccionesNotificaciones: [],
      usuarios:[],
      medios:[],
      causas: [],
      subcausas: [],
      editedItem:{//Objeto donde se guardara la informacion del registro que se esta editando o el registro que se va a crear
        idNotificacion: -1,
        idSeccion: -1,
        seccion: '',
        idSubSeccion: -1,
        subSeccion: '',
        idUsuario: -1,
        usuario: '',
        idMedioEnvio: -1,
        medioEnvio: '',
        activo: 1,
        mantenimiento: 1,
        causa: null,
        subcausa: null
      },
      defaultItem:{
        idNotificacion: -1,
        idSeccion: -1,
        seccion: '',
        idSubSeccion: -1,
        subSeccion: '',
        idUsuario: -1,
        usuario: '',
        idMedioEnvio: -1,
        medioEnvio: '',
        activo: 1,
        mantenimiento: 1,
        causa: null,
        subcausa : null
      }
      
    }),
    computed: { //Relacionada con el titulo de edicion y de creacion, el formulario es el mismo, lo que cambia es la variable editedIndex
      formTitle () {//Al darle click en el boton de agregar, la variable editedIndex se establece en -1 y al darle click dese un icono de edicion el valor cambiara
        return this.editedIndex === -1 ? 'Asignar Nueva Persona' : 'Editar'
      },
      subcausasFiltradas() {
      return this.editedItem.causa
        ? this.subcausas.filter(s => s.idParoTipo === this.editedItem.causa)
        : [];
      },
      nombreCausas() {
        return Object.fromEntries((this.causas || []).map(c => [c.idParoTipo, c.nombre]));
      },
      nombreSubcausas() {
        return Object.fromEntries((this.subcausas || []).map(s => [s.idSubParoTipo, s.nombreSubParoTipo]));
      },
      cambioSubcausa() {
        return Object.fromEntries((this.subcausas || []).map(s => [s.idSubParoTipo, s.idParoTipo]));
      },
      filasOrdenadas() {
        const out = [];
        for (const sec of this.seccionNotificaciones || []) {
          for (const sub of sec.subseccionesNotificacions || []) {
            for (const usr of sub.usuariosAsignados || []) {
              for (const med of usr.medios || []) {
                out.push({
                  idNotificacion: med.idNotificacion,

                  idSeccion: sec.idSeccionNotificacion,
                  seccion: sec.nombre,

                  idSubSeccion: sub.idSubSeccion,
                  subseccion: sub.nombre,

                  idUsuario: usr.idUsuario,
                  usuario: usr.nombre,

                  idMedioEnvio: med.idMedioEnvio,
                  medio: med.medioEnvio,

                  activo: med.activo,
                  mantenimiento: med.llamadoMantenimiento,

                  idParoTipo: med.idParoTipo ?? null,
                  idSubParoTipo: med.idSubParoTipo ?? null,
                  causaNombre: this.nombreCausas?.[med.idParoTipo] || null,
                  subcausaNombre: this.nombreSubcausas?.[med.idSubParoTipo] || null
                });
              }
            }
          }
        }
        return out;
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      'editedItem.causa'(nuevo) {
        const sc = this.editedItem.subcausa ? Number(this.editedItem.subcausa) : null;
        const causaNueva = nuevo ? Number(nuevo) : null;
        if (!causaNueva || (sc && this.cambioSubcausa[sc] !== causaNueva)) {
          this.editedItem.subcausa = null; // limpiar si no corresponde
        }
      },
    },  
    created () {//Manda a cargar la pagina
      this.initialize()
    },
    methods:{
        initialize(){//LLama a las funciones encargadas de obtener informacion del backend al momento de que cargue la pagina
            this.getConfiguracionNotificaciones();            
            this.getMediosEnvios();
            this.getUsuariosConfiguracionNotificaciones();
            this.getCausas();
            this.getTipoSubParos();
        },
      getCausas() {
        axios
          .get("/ParoTipos/ParoTipo")
          .then(response => {
            this.causas = response.data
          })
          .catch(error => {
            console.log(error)
          })
      },
    getTipoSubParos() {
			axios
				.get("/SubParoTipos")
				.then((response) => {
					this.subcausas = response.data;
				})
				.catch((error) => {
					console.log(error);
				});
		},

        getConfiguracionNotificaciones(){//Llama al backend para que le devuelva los datos con los que se llenara la tabla
            axios.get('/ConfiguracionNotificaciones')
            .then(response =>  {
					    this.seccionNotificaciones = response.data.map( notificaciones => ({
						    ...notificaciones                
					    }))
            })            
            .catch(error => {            
                console.log(error)
            })
            .finally(() => {
                this.loading = false;
            })
            
        },       

        getSubSecciones(){//Llama al backend para que le devuelva los datos con los que se llenara la lista desplegable de las subsecciones al momento de hacer la edición
          //En este caso, hacemos la busqueda por medio del id de la seccion que quedo seleccionada en el recuadro anterior
          //Si this.editedItem.seccion.idSeccionNotificacion se encuentra vacio usamos el valor que se encuentra en this.editedItem.idSeccion
          var listaId=this.$utils.strings.isNullOrEmpty(this.editedItem.seccion.idSeccionNotificacion)?this.editedItem.idSeccion:this.editedItem.seccion.idSeccionNotificacion;  
          axios.get('/ConfiguracionNotificaciones/SubSeccionesNotificaciones/'+ listaId)
            .then(response =>  {
					    this.subSeccionesNotificaciones = response.data.map( subSeccion => ({
						    ...subSeccion                
					    }))
            })    
            .catch(error => {                         
                console.log(error)
            })
            .finally(() => {
                this.loading = false;
            })
        
        },

        getMediosEnvios(){//Llama al backend para que le devuelva los datos con los que se llenara la lista desplegable de los medios de envio al momento de hacer la edición
            axios.get('/ConfiguracionNotificaciones/MediosEnvios')
            .then(response =>  {
					    this.medios = response.data.map( mediosEnvio => ({
						    ...mediosEnvio                
					    }))
            })    
            .catch(error => {            
                console.log(error)
            })
            .finally(() => {
                this.loading = false;
            })
        },

        getUsuariosConfiguracionNotificaciones(){//Llama al backend para que le devuelva los datos con los que se llenara la lista desplegable de los usuarios al momento de hacer la edición
            axios.get('/ConfiguracionNotificaciones/UsuariosConfiguracionNotificacion')
            .then(response =>  {
					    this.usuarios = response.data.map( users => ({
						    ...users                
					    }))
            })    
            .catch(error => {            
                console.log(error)
            })
            .finally(() => {
                this.loading = false;
            })
        },

        editItem (idNotifica, idSecc, secc, idSubsecc, subsecc, idUsuari, usuari, IdMedia, media, activ, mante, idCaus, idSubcaus) {//Mandar por aqui los componentes para armarlos en un objeto y visualizarlos en la ventana de edicion
          this.action = 1;// Se configura la variable action para declarar que se esta editando
          const userObj = this.usuarios.find(u => u.idUsuario === idUsuari) || { idUsuario: idUsuari, nombre: usuari };
          this.editedItem = Object.assign({},//Se recopila la informacion para que sea visible en la ventana de edicion
            {idNotificacion: idNotifica},
            {idSeccion: idSecc},
            {seccion: secc},
            {idSubSeccion: idSubsecc},
            {subSeccion: subsecc},
            {idUsuario: idUsuari},
            {usuario: userObj},
            {idMedioEnvio: IdMedia},
            {medioEnvio: media},
            {activo: activ},
            {mantenimiento: mante},
            {causa: idCaus || null},
            {subcausa: idSubcaus || null})
          this.editedIndex = this.editedItem.idNotificacion//Se edita la variable editedIndex con el fin de configurar el titulo del cuadro de dialogo
          
          this.dialog = true
        },

        deleteItem (item) {//Funcion para eliminar un item de la lista
          this.eliminar = true;
          this.delItem = item;
        },
        deleteItemDB(){//Funcion para eliminar un item de la lista, llama al backend para que elimine el item de la base de datos
          let me = this;
          let itemId = this.delItem;
          this.delItem = -1;
          axios
          .put("/ConfiguracionNotificaciones/EliminarConfiguracionNotificacion/" + itemId)
          .then(() =>  {
            me.initialize();
          })
          .catch(error => {
            console.log(error);
          });

        },

        close() {//Funcion que se encarga de cerrar los formularios al momento de oprimir el boton de cancelar, donde los valores alterados al momento de tratar de crear o editar un registro vuelven a sus valores por defecto
            this.action = 0,
            this.dialog = false
            this.editedItem = Object.assign({}, this.defaultItem)            
            this.editedIndex = -1            
            this.ups++;
        
        },
        validate(){//Validaciones para asegurarse de que no envien formularios vacios o incompletos
        this.errores =  [];
        this.errorTiempo = false;

        const medioId = this.editedItem.medioEnvio?.idMedioEnvio || this.editedItem.idMedioEnvio;
        if (
          !medioId
        )
        {
          this.alerta = true;
          this.errores.push(
            "Debe seleccionar un Medio de Envio."
          );
        }    
        
        const subId = this.editedItem.subSeccion?.idSubSeccion || this.editedItem.idSubSeccion;
        if (
          !subId         
        )
        {
          this.alerta = true;
          this.errores.push(
            "Debe seleccionar una Subsección."
          );
        }
        
        const secId = this.editedItem.seccion?.idSeccionNotificacion || this.editedItem.idSeccion;
        if (
          !secId    
        )
        {
          this.alerta = true;
          this.errores.push(
            "Debe seleccionar una Sección."
          );
        }

        const usrId = this.editedItem.usuario?.idUsuario || this.editedItem.idUsuario;
        if (
          !usrId         
        )
        {
          this.alerta = true;
          this.errores.push(
            "Debe seleccionar un Usuario."
          );
        }

        return this.errores.length == 0;
      },
      validateList(){//Validamos si se encuentra un id aceptable en la seccion
        //Para ello debemos contemplar los lugares donde se puede encontrar el id de la seccion, el el caso de que no se encuentre donde guardamos la informacion nueva buscamos en donde guardamos la informacion nueva
        var lista=this.$utils.strings.isNullOrEmpty(this.editedItem.seccion.idSeccionNotificacion)?this.editedItem.idUsuario:this.editedItem.seccion.idSeccionNotificacion;
        if (lista < 1 )//En caso de que todavía no se haya seleccionado una seccion lanzara un mensaje de error
        {
          this.alerta = true;
          this.errores.push(
            "Debe seleccionar una Sección antes de poder elegir una Subsección."
          );
        }
      },
      editar(row) {
        this.editItem(
          row.idNotificacion,
          row.idSeccion, row.seccion,
          row.idSubSeccion, row.subseccion,
          row.idUsuario, row.usuario,
          row.idMedioEnvio, row.medio,
          +!row.activo, +!row.mantenimiento,
          row.idParoTipo, row.idSubParoTipo
          );
          this.editedItem.idSubSeccion = row.idSubSeccion;
          this.getSubSecciones();
        },
        save () {
        this.action = 0;
        if(this.validate()){
          let me = this;
          me.saving = true;
          if (this.editedIndex > -1)
          {
            //Código para editar
            //this.editedItem.usuario.idUsuario guardara los datos que se vayan a editar, mientras que
            //this.editedItem.idUsuario guarda los datos ya guardados, en el caso de que haya datos que acualizar se mandara
            //this.editedItem.usuario.idUsuario y en caso de que se mantengan igual se mandara this.editedItem.idUsuario
            //De este modo se mantienen los datos no alterados
            axios
              .put("/ConfiguracionNotificaciones/ActualizarConfiguracionNotificacion/"+this.editedItem.idNotificacion, {
                idUsuario: this.$utils.strings.isNullOrEmpty(this.editedItem.usuario.idUsuario)?this.editedItem.idUsuario:this.editedItem.usuario.idUsuario,
                idSubSeccion: this.$utils.strings.isNullOrEmpty(this.editedItem.subSeccion.idSubSeccion)?this.editedItem.idSubSeccion:this.editedItem.subSeccion.idSubSeccion,
                idMedioEnvio: this.$utils.strings.isNullOrEmpty(this.editedItem.medioEnvio.idMedioEnvio)?this.editedItem.idMedioEnvio:this.editedItem.medioEnvio.idMedioEnvio,
                activo: !this.editedItem.activo,
                llamadoMantenimiento: !this.editedItem.mantenimiento,
                idParoTipo: this.editedItem.causa,
                idSubParoTipo: this.editedItem.subcausa
                
              })
              .then(() =>  {//Se deja todo como estaba
                this.saving = false;
                this.close();
                this.initialize();
              })
              .catch(error => {
                this.saving = false;
                if (error.response) {
                  if(error.response.status == 409){
                    this.alerta = true;
                    this.errores.push("Existe un registro Activo con los mismos datos");
                  }
                  if(error.response.status == 404){
                    this.alerta = true;
                    this.errores.push("El registro no se encuentra en la base de datos");
                  }
                }
              });
          }
          else
          {
            //Codigo para crear nuevos registros
            //En el caso del idUsuario, como todos los datos seran nuevos, bastara con mandarlo desde this.editedItem.usuario.idUsuario
            axios
              .post("/ConfiguracionNotificaciones/", {
                idUsuario: this.editedItem.usuario.idUsuario,
                idSubSeccion: this.editedItem.subSeccion.idSubSeccion,
                idMedioEnvio: this.editedItem.medioEnvio.idMedioEnvio,
                activo:!this.editedItem.activo,
                llamadoMantenimiento: !this.editedItem.mantenimiento,
                idParoTipo: this.editedItem.causa,
                idSubParoTipo: this.editedItem.subcausa

              })
              .then(() =>  {//Se deja todo como estaba
                this.saving = false;
                this.close();
                this.initialize();
              })
              .catch(error => {
                this.saving = false;
                if (error.response) {
                  if(error.response.status == 409){
                    this.alerta = true;
                    this.errores.push("Existe un registro Activo con los mismos datos");
                  }
                }
              });
          }
        }
      },

    },
    filters: {
      
    }
}
</script>